module.exports = __webpack_public_path__ + "static/media-box-43974b7b3d019ecb665cdb992adf6e65.png";